import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Space, Input, Button, Form, Upload, Select, Checkbox, DatePicker } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { filter } from 'lodash';
import dayjs from 'dayjs';

import * as constants from '../constants';

import uistate from '../../uistate';
import globalappstate from '../../globalappstate';
import common from '../../../common';
import currentuser from '../../currentuser';

const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;

class NewDossierFileForm extends Component {

    state = {
        fileList: [],
        uploading: false,
        idFileType: 99, //default: overige
        description: '',
        date: null,
    }

    cancel = () => {
        this.props.onCancel();
    }
    saveChanges = () => {
        if (this.state.fileList.length > 0) {
            const values = {
                file: this.state.fileList[0],
                idFileType: parseInt(this.state.idFileType),
                description: this.state.description,
                date: dayjs.isDayjs(this.state.date) ? this.state.date.utc(true).toISOString() : this.state.date
            }
            console.log(values);
            this.props.onSave(values);
        }
    }
    handleChangeSelectFileType = (value) => {
        this.setState(state => ({
            idFileType: value
        }));
    }
    handleChangeDescription = (value) => {
        this.setState(state => ({
            description: value
        }));
    }
    handleChangeDate = (value) => {
        this.setState(state => ({
            date: value
        }));
    }
    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'NewDossierFileForm', key);
    }

    render() {
        const formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
        }
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 14,
                    offset: 4,
                },
            },
        }
        const { fileList } = this.state;
        const userHasReadonlyRights = false; //!this.props.currentUsersCompanyRights.includes(common.rights.BedrijfMuteren);

        //toon filetyp dropdown adhv dossier type
        const showFileType = this.props.dossiertype == common.DOSSIER_TYPES.ProcessingActivity || 1 == 2; //uitbreiden adhv dossiertypes...
        const dossiertype = this.props.dossiertype;
        const fileTypes = filter(this.props.picklists.fileTypes, function (t) {
            return t.usedIn.includes(',' + dossiertype + ',');
        });

        const props = {
            onRemove: (file) => {
                this.setState((state) => {
                    const index = state.fileList.indexOf(file);
                    const newFileList = state.fileList.slice();
                    newFileList.splice(index, 1);
                    return {
                        fileList: newFileList,
                    };
                });
            },
            beforeUpload: (file) => {
                this.setState(state => ({
                    fileList: [file],
                }));
                return false;
            },
            fileList,
        };

        return (
            <div className='newdossierfile-details'>
                <Form layout='horizontal' className='linkeddossierfiles-details-form'>

                    <FormItem label={this.label("File")}{...formItemLayout}>
                        <Upload {...props}>
                            <Button icon={<UploadOutlined />}>{this.label("SelectFile")}</Button>
                        </Upload>
                    </FormItem>
                    {showFileType &&
                        <>
                            <FormItem label={this.label("FileType")} {...formItemLayout}>
                                <Select showSearch optionFilterProp="children"
                                    filterOption={true}
                                    placeholder={this.label("DdlPlaceholder")}
                                    value={this.state.idFileType}
                                    onChange={this.handleChangeSelectFileType}
                                >
                                    {
                                        fileTypes.map(o => <Option key={o.id} value={o.id}>{o.name}</Option>)
                                    }
                                </Select>
                            </FormItem>
                            <FormItem label={this.label("Date")} {...formItemLayout}>
                                <DatePicker
                                    placeholder={this.label("DatePlaceholder")}
                                    value={this.state.date}
                                    onChange={this.handleChangeDate}
                                    format={'DD-MM-YYYY'}
                                    allowClear={true}
                                    showTime={false}
                                />
                            </FormItem>
                        </>
                    }
                    <FormItem label={this.label("Description")}{...formItemLayout}>
                        <TextArea value={this.state.description} onChange={(e) => this.handleChangeDescription(e.target.value)} rows={4} />
                    </FormItem>

                    <FormItem {...tailFormItemLayout}>
                        <Space.Compact className='linkedfile-form-btns'>
                            <Button onClick={this.cancel} disabled={userHasReadonlyRights}>{this.label("Cancel")}</Button>
                            <Button onClick={this.saveChanges} type="primary" disabled={userHasReadonlyRights}>{this.label("Save")}</Button>
                        </Space.Compact>
                    </FormItem>
                </Form>
            </div>
        );
    }
}
NewDossierFileForm.defaultProps = {
    dossiertype: -1
}

function mapStateToProps(state) {
    return {
        labels: uistate.selectors.uiLabels(state),
        picklists: globalappstate.selectors.allPicklists(state),
    };
}

export default connect(mapStateToProps, {})(NewDossierFileForm);  